<template>
	<div class="container-configuration-reserves-professional-management">
		<ui-card
			icon="fal fa-gear"
        	title="Reservas - Funcionalidade"
		>
			<template #body>
				<div class="area-card">
					<transition name="small-fade">
						<div v-show="loader.bodyActions" class="loading-card">
							<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
						</div>
					</transition>
					<div
						v-for="(field, index) in form.field"
						:key="index"
						class="container-fields"
						:class="{'line-dashed': field.label == '2. Ações em Massa'}"
					>
						<span class="title-fields">
							{{ field.label }}
						</span>
						<div v-for="fields in field.actions" class="container-switch">
							<span>{{ fields.label }}</span>
							<ui-switch data-ui="configurations-professional-management" design="xs" v-model="fields.active" :checked="fields.active" />
						</div>
					</div>
				</div>
			</template>

			<template #fl/>

			<template #fr>
				<ui-button
					design="md success"
					data-ui="configurations-professional-management-save"
					:disabled="!canSubmit"
					@click="submitActions"
				>
					<span v-if="loader.buttonActions" class="loading-submit-user">
						<ui-load-indicator bg-color="#fff" color="#41A870" :h="20" :stroke="6" />
					</span>
					Salvar
				</ui-button>
			</template>
		</ui-card>
	</div>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { uiCard } from '@/components/ui/cards'
import { uiSwitch } from '@/components/ui/form'
import { uiLoadSuccess } from '@/components/ui/overlays'
import { alertMixin, formMixin } from '@/mixins'
import { reserves } from '@/services/axios'

const defaultFormActions = () => ({
	field: [
		{
			label: '1. Limite de Reservas',
			actions: [
				{
					type: 'teams',
					active: false,
					label: 'Permitir limitar a quantidade de Reservas por Equipe',
					name: 'global_reserves_limit_teams'
				},
				{
					type: 'users',
					active: false,
					label: 'Permitir limitar a quantidade de Reservas por Usuário',
					name: 'global_reserves_limit_users'
				},
				{
					type: 'units_teams',
					active: false,
					label: 'Permitir definir unidades exclusivas para Equipes',
					name: 'global_reserves_limit_units_teams'
				}
			]
		},
		{
			label: '2. Ações em Massa',
			actions: [
				{
					type: 'cancel',
					active: false,
					label: 'Cancelar múltiplas reservas',
					name: 'global_reserves_bulk_cancel'
				},
				// {
				// 	type: 'confirm-multiple-reservations',
				// 	value: false,
				// 	label: 'Confirmar venda de múltiplas reservas'
				// },
				// {
				// 	type: 'renew-time-multiple-reservations',
				// 	value: false,
				// 	label: 'Renovar o tempo de múltiplas reservas.'
				// }
			]
		},
	],
})

const defaultLoader = () => ({
	bodyActions: false,
	buttonActions: false
})

export default {
	name: 'configuration-reserves-professional-management',

	components: {
		uiCard,
		uiButton,
		uiSwitch,
		uiLoadSuccess,
		uiLoadIndicator
	},

	mixins: [
		alertMixin,
		formMixin
	],

	data() {
		return {
			form: { ...defaultFormActions() },
			loader: { ...defaultLoader() },
			oldForm: {}
		}
	},
	computed: {
		canSubmit() {
			return this.$mx_isFormChanged && !this.loader.bodyActions && !this.loader.buttonActions
		},
	},

	async created() {
		await this.loadActions()

		this.$mx_copyOldForm()
	},

	methods: {
		async loadActions() {
			this.loader.bodyActions = true
			try {
				const response = await reserves.getConfigGlobal()
				this.formatFormActions(response.data.data)
				this.loader.bodyActions = false
			} catch (error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				}
				this.loader.bodyActions = false
			} finally {
				this.loader.bodyActions = false
			}
		},

		async submitActions() {
			this.loader.buttonActions = true
			let configurations = []

			this.form.field.forEach(item => {
				item.actions.forEach(value => {
					configurations.push({
						active: value.active,
						name: value.name
					})
				})
			})

			try {
				const response = await reserves.postConfigGlobal(configurations)
				this.$mx_alertSuccess(response.data.msg)
				this.$mx_copyOldForm()
				this.buttonActions = false
			} catch (error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				} else {
					this.$mx_alertError(error)
				}
			} finally {
				this.loader.buttonActions = false
			}
		},

		formatFormActions(data) {
			this.form.field.forEach(field => {
				field.actions.forEach(action => {
					if (data.hasOwnProperty(action.name)) {
						action.active = data[action.name].active
					}
				})
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
	@import './styles.styl'
</style>
